import rest from '../rest/rest-service';

const denialCodeMapResource = '/pa-denialcodemap';
export const DenialCodeMapService = {
    async post(body) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}${denialCodeMapResource}`, body);   
    },
    async put(id, body) {
        return rest.put(`${process.env.PA_ADMIN_API_URL_V2}${denialCodeMapResource}/${id}`, body);   
    },
    async get(id) {
        return rest.get(`${process.env.PA_ADMIN_API_URL_V2}${denialCodeMapResource}/${id}`);   
    },
    async search(body) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}${denialCodeMapResource}/search`, body);    
    },
    async delete(id, body) {
        return rest.del(`${process.env.PA_ADMIN_API_URL_V2}${denialCodeMapResource}/${id}`, body);   
    }
};



// WEBPACK FOOTER //
// ./src/services/pa/denial-code-map.service.js